import React from "react";
import TableHeader from "../tableheader";
import TableRow from "../tablerow";

class Schedule extends React.Component {

  render() {
    return (
      <table className="table">
        <thead>
          <TableHeader
            day="Day"
            event="Event"
            notes="Notes"
            time="Time"
            where="Location"
          />
        </thead>
        <tbody>

          {/* Thursday */}
          <TableRow
            color="purple"
            day="Thursday"
            event="Arrival & Check-in"
            notes="Paperwork and Orientation"
            time="2:00 pm - 7:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="purple"
            event="Supper &amp; Fellowship"
            notes=""
            time="4:00 pm - 6:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="purple"
            event="[Message]: &quot;Where is our Absolute?&quot;"
            notes="Speaker: Dan Gross"
            time="6:30 pm - 7:30 pm"
            where="The Chapel"
          />

          <TableRow
            color="purple"
            event="Fellowship & Music"
            time="8:00 pm - 10:30 pm"
          />

          {/* Friday */}
          <TableRow
            color="blue"
            day="Friday"
            event="Dining Room Discussions"
            notes="Coffee, Muffins, and Q&amp;A"
            time="6:30 am - 7:30 am"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="Breakfast"
            notes=""
            time="8:00 am - 9:00 am"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="[Message]: &quot;Studying your Bible&quot;"
            notes="Speaker: Justin Bellows"
            time="9:30 am - 10:30 am"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="Break"
            notes="Stretch legs"
            time="10:30 am - 10:45 am"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="[Message]: &quot;Why do we study the Bible?&quot;"
            notes="Speaker: Billy Elmquist"
            time="10:45 am - 12:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="Lunch"
            notes=""
            time="12:30 pm - 2:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="Free Time"
            time="2:00 pm - 4:30 pm"
          />

          <TableRow
            color="blue"
            event="[Message]: Women&apos;s Meeting"
            notes="Speaker: Lisa Ann Spencer"
            time="3:30 pm - 4:30 pm"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="Supper"
            notes=""
            time="5:30 pm - 6:30 pm"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="[Message]: &quot;God&apos;s Will for Everybody&quot;"
            notes="Speaker: Barney Monroe"
            time="7:00 pm - 8:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="[Message]: &quot;Understanding our Dual Nature&quot;"
            notes="Speaker: Paul Lucas"
            time="8:15 pm - 9:15 pm"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="Fellowship & Music"
            time="9:30 pm - 10:30 pm"
            where="The Chapel"
          />

          {/* Saturday */}
          <TableRow
            color="green"
            day="Saturday"
            event="Dining Room Discussions"
            notes="Coffee, Muffins,  and Q&A"
            time="6:30 am - 8:00 am"
            where="Dining Hall"
          />

          <TableRow
            color="green"
            event="Breakfast"
            notes=""
            time="8:00 am - 9:00 am"
            where="Dining Hall"
          />

          <TableRow
            color="green"
            event="[Message]: Timothy Sessions"
            notes="Speakers: Young Men"
            time="9:30 am - 11:15 am"
            where="The Chapel"
          />

          <TableRow
            color="green"
            event="[Message]: &quot;Family Structure&quot;"
            notes="Speaker: Larry Gabbard"
            time="11:15 am - 12:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="green"
            event="Lunch"
            notes=""
            time="12:30 pm - 2:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="green"
            event="Camp Photo"
            notes="Report to Kadee Luethge"
            time="2:15 pm"
            where="Chapel Yard"
          />

          <TableRow
            color="green"
            event="[Message]: Men&apos;s Meeting"
            notes="Speaker: Billy Elmquist"
            time="2:30 pm - 3:30 pm"
            where="The Chapel"
          />

          <TableRow
            color="green"
            event="Relay Race"
            notes="Report to Scott Gross"
            time="4:00 pm - 5:30 pm"
            where="Chapel Yard"
          />

          <TableRow
            color="green"
            event="Supper"
            notes=""
            time="5:30 pm - 6:30 pm"
            where="Dining Hall"
          />

          <TableRow
            color="green"
            event="[Message]: &quot;The Love of God&quot;"
            notes="Speaker: Bill Barnett"
            time="7:00 pm - 8:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="green"
            event="[Q&amp;A]: Panel Questions and Answers"
            notes="Speakers"
            time="8:00 pm - 9:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="green"
            event="Fellowship & Music"
            time="9:00 pm - 11:00 pm"
            where="The Chapel"
          />

          {/* Sunday */}
          <TableRow
            color="red"
            day="Sunday"
            event="Breakfast"
            notes=""
            time="8:00 am - 9:00 am"
            where="Dining Hall"
          />

          <TableRow
            color="red"
            event="[Message]: &quot;God's Purpose for All&quot;"
            notes="Speaker: Paul Lucas"
            time="9:30 am - 10:45 am"
            where="The Chapel"
          />

          <TableRow
            color="red"
            event="[Message]: &quot;Them that Love God&quot;"
            notes="Speaker: Barney Monroe"
            time="11:00 am - 12:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="red"
            event="Lunch"
            notes=""
            time="12:30 pm - 2:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="red"
            event="Clean Up"
            notes="Cabins, The Chapel, and Dining Hall"
            time="2:00 pm - 3:30 pm"
            where="All Buildings"
          />

        </tbody>
      </table>
    );
  }

}

export default Schedule;
